import React, { Component } from 'react';
import { connect } from 'react-redux';

import { initModal, pushModal } from 'shared/actions/modal.action';

import Dim from 'web/components/common/modal/common/Dim';

import { logout } from 'shared/actions/auth.action';

@connect(
  (state, props) => ({
    auth: state.shared.auth,
    modal: state.shared.modal,
  }),
  {
    initModal,
    pushModal,
    logout,
  },
)
class AlertContainer extends Component {
  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const { modal = {} } = this.props;

    return (
      <Dim>
        <div
          className="modal"
          style={{
            position: 'relative',
            width: '300px',
            padding: '40px 40px 60px',
            backgroundColor: '#fff',
            color: '#000',
            borderRadius: '10px',
            overflow: 'hidden',
            textAlign: 'center',
            fontSize: '14px',
            lineHeight: '1.4',
          }}
        >
          <div
            style={{
              textAlign: 'left',
              marginBottom: '20px',
            }}
            dangerouslySetInnerHTML={{ __html: modal.data.html }}
          />
          <button
            onClick={this.props.popupHandler.close}
            style={{
              width: '100%',
              height: '40px',
              lineHeight: '40px',
              backgroundColor: '#3b3283',
              color: '#fff',
              // borderRadius: '',
              position: 'absolute',
              left: '0',
              bottom: '0',
            }}
          >
            닫기
          </button>
        </div>
      </Dim>
    );
  }
}

export default AlertContainer;
